var path = 'components/side-menu.tpl.html';
var html = "\r\n<ul flex layout=\"column\" layout-align=\"start stretch\" class=\"tb-side-menu\">\r\n   \t  <li ng-repeat=\"section in sections\" class=\"parent-list-item\" ng-class=\"{'parentActive' : isOpen(section)}\"> \r\n\t\t\t<tb-menu-link section=\"section\"></tb-menu-link>\r\n      </li>\r\n</ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/side-menu.tpl.html
// module id = 1415
// module chunks = 1